<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="사업안내" tabActive="특장점 안내" bg="/images/sub/business/visual.jpg">
                <template #title>사업안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>특장점 안내</template>
            <v-row class="row--xxs">
                <template v-for="(item, index) in items">
                    <v-col :key="index" cols="12" sm="6" xl="3">
                        <v-img :src="item.icon" class="feature-icon" />
                        <tit class="tit--sm text-center mb-20px mb-md-34px">
                            {{ item.name }}
                        </tit>
                        <v-sheet color="grey lighten-5" class="pa-16px feature-sheet">
                            <txt class="txt--lg text-pre-wrap grey--text font-weight-medium break-keep line-height-15">
                                <template v-for="(child, index) in item.children">
                                    <v-row :key="index" class="row--xxs">
                                        <v-col cols="auto">·</v-col>
                                        <v-col>{{ child }}</v-col>
                                    </v-row>
                                </template>
                            </txt>
                        </v-sheet>
                    </v-col>
                </template>
            </v-row>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        Tit,
        Txt,
    },
    data: () => ({
        items: [
            {
                icon: "/images/sub/business/feature/feature-1.svg",
                name: "초역세권 교통",
                children: [
                    "2호선, 7호선 건대입구역\r\n더블 초역세권",
                    "강변북로, 올림픽대로, 청담대교, 영동대교 등 광역도로 인접",
                    //
                ],
            },
            {
                icon: "/images/sub/business/feature/feature-2.svg",
                name: "청년-신혼부부세대 편의시설",
                children: [
                    "롯데백화점, 이마트, CGV 등 다양한 생활 편의시설",
                    "건대로데오거리, 양꼬치거리, 맛의거리 등 문화와 쇼핑 거리",
                    "건국대병원, 예술회관 등 생활편의시설 위치",
                    //
                ],
            },
            {
                icon: "/images/sub/business/feature/feature-3.svg",
                name: "숲세권",
                children: [
                    "뚝섬한강공원, 어린이 대공원 등 쾌적한 자연환경",
                    "한강이 내려다 보이는 24층 대형 커뮤니티",
                    //
                ],
            },
            {
                icon: "/images/sub/business/feature/feature-4.svg",
                name: "통학 편의성",
                children: [
                    "건국대, 세종대 접근이 용이해 최적의 통학 입지",
                    "자양초,중,고등학교, 건국대학교 사범부속고등학교 등 인접하여 최적의 통학 입지",
                    //
                ],
            },
        ],
    }),
};
</script>

<style lang="scss" scoped>
.feature-icon {
    max-width: 60px;
    margin: 30px auto 10px;
}
@media (min-width: 768px) {
    .feature-icon {
        max-width: 80px;
    }
    .feature-sheet {
        min-height: 210px;
    }
}
</style>
